export default __webpack_public_path__ + "static/media/property_498.96e9d070.png";